import { defineMessages } from 'react-intl';

export const i18n: {
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterLabelPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectedOptionsSection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterLabelsNoText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	suggestedOptionsSection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	label: {
		id: 'search-page.filters.names.labels',
		defaultMessage: 'Label',
		description:
			'The text is shown as the filter name label in the search filter bar, allowing users to narrow Confluence results by content label.',
	},
	confluenceFilterLabelPlaceholder: {
		id: 'search-page.confluence.filter.labels.placeholder',
		defaultMessage: 'Find labels',
		description: 'Placeholder for label filter search input',
	},
	selectedOptionsSection: {
		id: 'search-page.confluence.filter.label.selected',
		defaultMessage: 'Selected',
		description:
			'The text is shown as a section heading in the Confluence label filter drop-down, grouping options the user has already chosen.',
	},
	confluenceFilterLabelsNoText: {
		id: 'advanced-search.labels.filter.no.text',
		defaultMessage: 'Start typing to search for a label',
		description: "Text displayed when the user hasn't begun typing a label",
	},
	suggestedOptionsSection: {
		id: 'search-page.filter.suggested.options.section',
		defaultMessage: 'Suggested',
		description:
			'The text is shown as a section heading in a filter drop-down, grouping options that are recommended to the user but not yet selected.',
	},
});
